import { render, staticRenderFns } from "./CenterViewDraft_Ap.vue?vue&type=template&id=8bb4bdd0&scoped=true"
import script from "./CenterViewDraft_Ap.vue?vue&type=script&lang=js"
export * from "./CenterViewDraft_Ap.vue?vue&type=script&lang=js"
import style0 from "./CenterViewDraft_Ap.vue?vue&type=style&index=0&id=8bb4bdd0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bb4bdd0",
  null
  
)

export default component.exports